// extracted by mini-css-extract-plugin
export default {"root":"EditUserRoleModal_root__n1E6A","container":"EditUserRoleModal_container__-nbKU"};